import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './Day.module.css';
import { Day, type DayType } from './Day.tsx';
import { MonthSkeleton } from './MonthSkeleton.tsx';

type RenderDaysProps = {
  month: DayType[];
  uniqueWeekNumbers: number[];
  isExport?: boolean;
  isLoading?: boolean;
};

export const RenderDays = ({ month, uniqueWeekNumbers, isExport = false, isLoading = false }: RenderDaysProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <MonthSkeleton />;
  }

  if (isExport) {
    return (
      <div className={styles.isExport}>
        <div className={`${styles.dayWrapper} ${styles.dayWrapperExport}`}>
          <p className={`${styles.start} ${styles.isExport}`}>{t('salary.start')}</p>
          <p className={`${styles.stop} ${styles.isExport}`}>{t('salary.end')}</p>
          <p className={styles.lunch}>{t('salary.lunch')}</p>
          <p className={styles.total}>{t('salary.total')}</p>
          <p className={styles.brutto}>{t('salary.brutto')}</p>
        </div>
        <div className={styles.isExport}>
          {month.map((date) => (
            <Day date={date} key={date.id} isExport={isExport} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      {uniqueWeekNumbers?.map((weekNumber) => {
        return (
          <div key={weekNumber}>
            <div className={`${styles.weekWrapper} ${isExport ? styles.isExport : ''}`}>
              <p className={styles.weekdayMobile}>
                {t('salary.week')} {weekNumber}:
              </p>
              <div className={`${styles.dayWrapper} ${isExport ? styles.dayWrapperExport : ''}`}>
                {!isExport && <p className={styles.workday} />}
                <p className={styles.weekday}>
                  {t('salary.week')} {weekNumber}:
                </p>
                <p className={`${styles.start} ${isExport ? 'isExport' : ''}`}>{t('salary.start')}</p>
                <p className={`${styles.stop} ${isExport ? 'isExport' : ''}`}>{t('salary.end')}</p>
                <p className={styles.lunch}>{t('salary.lunch')}</p>
                <p className={styles.ordHours}>{t('salary.ordinaryHours')}</p>
                <p className={styles.overtimeHours}>{t('salary.overtime')}</p>
                {!isExport && <p className={styles.flexTime}>{t('salary.flex')}</p>}
                <p className={styles.total}>{t('salary.total')}</p>
                <p className={styles.brutto}>{t('salary.brutto')}</p>
              </div>
              {month
                .filter((date) => date.weekNumber === weekNumber)
                .map((date) => (
                  <Day date={date} key={date.id} isExport={isExport} />
                ))}
            </div>
            {!isExport && <Divider />}
          </div>
        );
      })}
    </div>
  );
};
